import CollapseTransition from './collapse-transition';

export default CollapseTransition;
